'use strict';
import {module} from '../app';

module.directive('scrollTop', [
    function () {
      return {
        restrict: 'A',
        link: function (scope, el, attrs) {

          scope.$watch(attrs.scrollTop, function (val) {
            if (val === true) {
              el.parent()[0].style.cssText = "";
              scope.$eval(attrs.scrollTop + '=' + false);
            }
          });

        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/directives/scrollTop.js